import { descriptors } from "../descriptors.js";
import { createSingletonLogger } from "../singleton-logger.js";
import { parsers } from "./parsers.js";

const BASE_DESCRIPTOR_NAMESPACE = "core:base";

class DescriptorParser {
  static componentName = "descriptor-parser";

  constructor() {
    createSingletonLogger(this);
    parsers.addType("descriptors", this._applyDescriptors.bind(this));
  }

  _applyDescriptors(build) {
    const buildDescriptors = build.descriptors.map((descriptor) => {
      // Automatically extend core:base for any descriptor that doesn't explicitly extend something else.
      // This ensures all entities inherit parentUid with default "app" unless they explicitly extend
      // a different descriptor (e.g., event extends core:data).
      if (!descriptor.extends && descriptor.namespace !== BASE_DESCRIPTOR_NAMESPACE) {
        descriptor.extends = BASE_DESCRIPTOR_NAMESPACE;
      }
      return descriptor;
    });

    const buildDescriptorsNamespaces = new Set(
      buildDescriptors.map((descriptor) => descriptor.namespace),
    );
    const usedDescriptorsNamespaces = new Set();
    const sortedDescriptors = [];

    while (buildDescriptors.length > 0) {
      const descriptor = buildDescriptors.shift();

      if (!descriptor.extends) {
        usedDescriptorsNamespaces.add(descriptor.namespace);
        sortedDescriptors.push(descriptor);
        continue;
      }

      const parentParsed = usedDescriptorsNamespaces.has(descriptor.extends);
      if (parentParsed) {
        usedDescriptorsNamespaces.add(descriptor.namespace);
        sortedDescriptors.push(descriptor);
        continue;
      }

      if (!buildDescriptorsNamespaces.has(descriptor.extends)) {
        this.error(
          `Descriptor [${descriptor.namespace}] tries to extend a descriptor [${descriptor.extends}] that doesn't exist, skipping`,
        );
        continue;
      }

      buildDescriptors.push(descriptor);
    }

    for (const descriptor of sortedDescriptors) {
      descriptors.create(descriptor);
    }
  }
}

const descriptorParser = new DescriptorParser();
export { DescriptorParser, descriptorParser };
